// extracted by mini-css-extract-plugin
export default {"copyLinkWithTextContainer":"CopyLinkWithText_copyLinkWithTextContainer__c8Awv"};